import { Field } from "formik";

interface FormTaxInfoProps {
    errors?: any;
    values?: any;
}

export function FormTaxInfo(props: FormTaxInfoProps) {
    const { errors } = props;

    return (
        <div className="row container-border-app">
            <div className="row">
                <div className="col-12 text-left">
                    <h3>Información Tributaria</h3>
                </div>
            </div>
            
            <div className="row">
                {/* Tipo de contribuyente */}
                <div className="col-md-4">
                    <div className="label-fields-peps-mobile display-flex">
                        Tipo de contribuyente
                    </div>
                    <div className="display-flex">
                        <Field
                            as="select"
                            name="Pws_tip_contri"
                            className={`${errors.Pws_tip_contri ? 
                                'form-know-you-item-input-smaller display-flex input-error' : 
                                'form-know-you-item-input-smaller display-flex'}`}
                        >
                            <option value="">Seleccione...</option>
                            <option value="Gran contribuyente">Gran contribuyente</option>
                            <option value="No gran contribuyente">No gran contribuyente</option>
                        </Field>
                    </div>
                </div>
                
                {/* Autoretenedor */}
                <div className="col-md-4">
                    <div className="label-fields-peps-mobile display-flex">
                        Autoretenedor
                    </div>
                    <div className="display-flex">
                        <Field
                            as="select"
                            name="Pws_auto_rete"
                            className={`${errors.Pws_auto_rete ? 
                                'form-know-you-item-input-smaller display-flex input-error' : 
                                'form-know-you-item-input-smaller display-flex'}`}
                        >
                            <option value="">Seleccione...</option>
                            <option value="si">Sí</option>
                            <option value="no">No</option>
                        </Field>
                    </div>
                </div>
                
                {/* Responsable IVA */}
                <div className="col-md-4">
                    <div className="label-fields-peps-mobile display-flex">
                        Responsable IVA
                    </div>
                    <div className="display-flex">
                        <Field
                            as="select"
                            name="Pws_ret_iva"
                            className={`${errors.Pws_ret_iva ? 
                                'form-know-you-item-input-smaller display-flex input-error' : 
                                'form-know-you-item-input-smaller display-flex'}`}
                        >
                            <option value="">Seleccione...</option>
                            <option value="si">Sí</option>
                            <option value="no">No</option>
                        </Field>
                    </div>
                </div>
            </div>
        </div>
    );
}